/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_TInputs */

const en_tut_rekam_t = /** @type {(inputs: Tut_Rekam_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording a meeting`)
};

const id_tut_rekam_t = /** @type {(inputs: Tut_Rekam_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merekam rapat`)
};

/**
* | output |
* | --- |
* | "Recording a meeting" |
*
* @param {Tut_Rekam_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_t = /** @type {((inputs?: Tut_Rekam_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_t(inputs)
	return en_tut_rekam_t(inputs)
});